import React from 'react';
import styled from 'styled-components';
import { tokens } from '../../config/themeTokens';
import { Heading, Text, Button } from '../primitives';

const Card = styled.article`
  padding: ${tokens.spacing.xl};
  border-radius: ${tokens.radius.lg};
  background: ${tokens.colors.backgroundAlt};
  border: 1px solid ${tokens.colors.border};
`;

export function PromoCard({ title, description, ctaLabel, ctaHref, children, ...props }) {
  return (
    <Card {...props}>
      {title && <Heading level={3}>{title}</Heading>}
      {description && <Text>{description}</Text>}
      {ctaLabel && ctaHref && (
        <Button as="a" href={ctaHref}>
          {ctaLabel}
        </Button>
      )}
      {children}
    </Card>
  );
}

export default PromoCard;
